module.exports = __webpack_public_path__ + "static/media/mercado-modelo-cartao-visita-768x591.bfe4058e.jpg";